import ESputnik from '@/utils/ESputnik/ESputnik';
import { store } from '@/store';
import GoogleAnalytics4 from './GoogleAnalytics4';

const isAuthorized = () => store?.state?.personal?.data?.authInfo?.isAuthorized;

export default class Analytics {
  static viewDetailProduct(product) {
    const dataLayerProduct = product?.dataLayerProduct;

    if (dataLayerProduct) {
      GoogleAnalytics4.viewItem({ ...dataLayerProduct, group_id: product.id });
    }
    // console.log(this.isAuthorized);
    // if (isAuthorized()) {
    ESputnik.productPage(product);
    // }
  }

  static clickOnProduct(product, pageNumber) {
    const dataLayerProduct = { ...product?.dataLayerProduct };

    if (!Object.keys(dataLayerProduct).length) {
      return console.warn('dataLayerProduct is empty', product);
    }

    if (pageNumber) {
      dataLayerProduct.item_list_id = `list ${pageNumber}`;
    }

    if (dataLayerProduct) {
      GoogleAnalytics4.selectItem(dataLayerProduct);
    }
  }

  static buyOneClick(items, generalData) {
    if (items) {
      GoogleAnalytics4.purchase(items, generalData);
    }
  }

  /** Catalog Events * */
  static viewCatalog(items, collection) {
    // console.log(collection);
    if (items?.length) {
      GoogleAnalytics4.viewItemList(
        items.map((el) => el.dataLayerProduct),
        collection?.name
      );

      // if (isAuthorized()) {
      ESputnik.categoryPage(collection?.googleCategoryId);
      // }
    }
  }
  /** End Catalog Events * */

  /** Checkout events * */
  static viewCheckout(items) {
    const products = items.map((el) => ({ ...el.dataLayerProduct, quantity: +el?.count || 1 }));

    if (products) {
      GoogleAnalytics4.beginCheckout(products);
    }
  }

  static confirmCheckout(thanksData, generalData) {
    const dataLayerProducts = thanksData?.order?.dataLayer?.products;
    const items = thanksData?.order?.items;
    // console.log(thanksData);
    if (dataLayerProducts) {
      GoogleAnalytics4.purchase(Object.values(dataLayerProducts), generalData);
    }
    if (items) {
      ESputnik.purchasedItems(items, thanksData?.order);
    }
  }
  /** Checkout events end * */

  /** Basket events * */
  static viewBasket(items, generalData) {
    if (items?.length) {
      GoogleAnalytics4.viewCart(
        items.map((el) => el.dataLayerProduct),
        generalData
      );
    }
  }

  static addToBasket(product) {
    const dataLayerProduct = product?.dataLayerProduct;

    if (dataLayerProduct) {
      GoogleAnalytics4.addToCart({ ...dataLayerProduct, quantity: 1, group_id: product.id });
    }

    if (isAuthorized()) {
      ESputnik.statusCart(store?.state?.basket?.data);
    }

    if (typeof fbq === 'function') {
      fbq('track', 'AddToCart', {
        content_ids: [product.id],
        content_type: 'product',
        value: product.price,
        currency: 'UAH',
      });
    }
  }

  static removeFromBasket(product) {
    const dataLayerProduct = product?.dataLayerProduct;

    if (dataLayerProduct) {
      GoogleAnalytics4.removeFromCart({ ...dataLayerProduct, quantity: +product?.count || 1 });

      if (isAuthorized()) {
        ESputnik.statusCart(store?.state?.basket?.data);
      }
    }
  }

  static updatedBasket() {
    ESputnik.statusCart(store?.state?.basket?.data);
  }
  /** End Basket events * */

  /** User events * */
  static signIn(customerData) {
    ESputnik.customerData(customerData);
  }

  /** End User events * */

  /** Search engine * */
  static search(searchData) {
    if (isAuthorized() && searchData.query && !searchData?.products?.items?.length) {
      ESputnik.searchRequest(searchData.query);
    }
  }
  /** End Search engine * */

  /** wishlist * */
  static addToWishlist(product) {
    if (isAuthorized()) {
      ESputnik.addToWishlist(product);
    }
  }
  /** End wishlist * */
}
